import { SActionBtn, SLowcodeList, STableActions } from 'shj-components'
import { forwardRef, useImperativeHandle, useRef, useState } from 'react'
import { useActivate } from 'react-activation'
import { useParams } from 'react-router-dom'

import config from './config.tsx'
import { getTradingStatementList } from '@/services/order.ts'
import {
  cancelPaymentApply,
  findDetailResponseByRequest,
  findJDResponseListByPage,
  paymentPayedWithLog,
} from '@/services/fmsServices.ts'
import { message } from 'antd'
import AddJdPaymentAplly from '../../addJdPaymentApply/index.tsx'
import Preview from './components/Preview.tsx'
import CancelModal from './components/CancelModal.tsx'

const JdReceivables = forwardRef((prpos: any, ref) => {
  const { detail } = prpos
  const { id } = useParams()
  const listRef = useRef<any>()
  const [dataInfo, setDataInfo] = useState<any>({})
  const [type, setType] = useState('')
  const [addJdOpen, setAddJdOpen] = useState(false)
  const [detailOpen, setDetailOpen] = useState(false)
  const [cancelOpen, setCancelOpen] = useState(false)
  const [record, setRecord] = useState<any>({})

  useActivate(() => {
    listRef.current?.reload()
  })
  useImperativeHandle(ref, () => {
    return {
      reload: () => listRef.current.reload(),
    }
  }, [listRef.current])
  const fetchList = (values: any) => {
    const { current, pageSize, query } = values
    return new Promise((resolve, reject) => {
      try {
        findJDResponseListByPage(current, pageSize, {
          orderAccountId: detail?.orderAccountId || '',
        })
          .then(res => {
            resolve({ records: res?.list || [], total: res?.count || 0 })
          })
          .catch(() => {
            reject({ success: false })
          })
      } catch {
        reject({ success: false })
      }
    })
  }
  const onClickTohandle = (type, record) => {
    setRecord(record)
    setType(type)
    let api: any
    let submitInfo: any = {}
    switch (type) {
      case 'detail':
        // 跳转详情
        setDetailOpen(true)
        api = findDetailResponseByRequest
        submitInfo = {
          jdPaymentApplyId: record.id,
        }
        break
      case 'modify':
        // 修改
        setAddJdOpen(true)
        api = findDetailResponseByRequest
        submitInfo = {
          jdPaymentApplyId: record.id,
        }
        break
      case 'cancel':
        // 取消支付
        setCancelOpen(true)
        // api = cancelPaymentApply
        // submitInfo = {
        //   id: record.id,
        // }
        break
      case 'createPayment':
        // 生成收款单
        api = paymentPayedWithLog
        submitInfo = {
          id: record.id,
        }
        break
      default:
        break
    }
    if (type === 'createPayment') {
      api({ ...submitInfo }).then(res => {
        message.success('操作成功')
        listRef.current?.reset()
      })
    } else if (type === 'detail' || type === 'modify') {
      // 编辑 详情
      api({ ...submitInfo }).then(res => {
        setDataInfo(res)
      })
    }
  }
  const extensions = {
    request: { fetchList },
    events: { reload: () => listRef.current?.reset() },
    customRender: {
      actions(type: string, record) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onClickTohandle('detail', record)}>详情</SActionBtn>
            {record.payState === 'jdPayStateWaitPay' && (
              <SActionBtn onClick={() => onClickTohandle('modify', record)}>修改</SActionBtn>
            )}
            {record.payState === 'jdPayStateWaitPay' && (
              <SActionBtn onClick={() => onClickTohandle('cancel', record)}>取消支付</SActionBtn>
            )}
            {record.payState === 'jdPayStateFinished' && record.transstate === 'E' && (
              <SActionBtn onClick={() => onClickTohandle('createPayment', record)}>
                生成收款单
              </SActionBtn>
            )}
          </STableActions>
        )
      },
    },
  }

  return (
    <>
      <SLowcodeList searchMode={'group'} ref={listRef} config={config} {...extensions} />
      <AddJdPaymentAplly
        title={'修改京东收款单'}
        open={addJdOpen}
        setOpen={setAddJdOpen}
        detailsInfo={detail}
        orderId={id}
        dataInfo={dataInfo}
        reload={listRef.current?.reload()}
      ></AddJdPaymentAplly>
      <Preview
        title={'京东收款单详情'}
        dataInfo={dataInfo}
        open={detailOpen}
        setOpen={setDetailOpen}
      ></Preview>
      <CancelModal
        title={'取消支付'}
        open={cancelOpen}
        record={record}
        setOpen={setCancelOpen}
        reload={listRef.current?.reload()}
      ></CancelModal>
    </>
  )
})

export default JdReceivables
